module.exports = __webpack_public_path__ + "img/cipta-dimensi.95f8b513.jpg";